exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ops-page[data-v-020ffba6]{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:16px}.ops-tabs[data-v-020ffba6]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:12px 16px 0 16px}", ""]);

// exports
